import React, { Component } from 'react'

class ClinicsInfo extends Component<any, any> {
    render() {
        const { serviceClinics, clinic_type_name } = this.props
        return (
            <div>
                {clinic_type_name ? (
                    <div>
                        <strong>סוג מרפאה</strong> <div>{clinic_type_name}</div>
                    </div>
                ) : (
                    <div>
                        <strong>ללא סוג מרפאה</strong>
                    </div>
                )}
                {serviceClinics && serviceClinics.length > 0 ? (
                    <div>
                        <strong>שירותי המרפאה</strong>
                        {serviceClinics.map((spec, index) => (
                            <div key={index}>- {spec.name}</div>
                        ))}
                    </div>
                ) : (
                    <div>
                        <strong>ללא שירותי מרפאה</strong>
                    </div>
                )}
            </div>
        )
    }
}

export default ClinicsInfo
